import { render, staticRenderFns } from "./BaseImg.vue?vue&type=template&id=33a44210"
import script from "./BaseImg.vue?vue&type=script&lang=js"
export * from "./BaseImg.vue?vue&type=script&lang=js"
import style0 from "./BaseImg.vue?vue&type=style&index=0&id=33a44210&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports